import { render, staticRenderFns } from "./InsCopyright.vue?vue&type=template&id=2e7e49da&scoped=true&"
import script from "./InsCopyright.vue?vue&type=script&lang=ts&"
export * from "./InsCopyright.vue?vue&type=script&lang=ts&"
import style0 from "./InsCopyright.vue?vue&type=style&index=0&id=2e7e49da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7e49da",
  null
  
)

export default component.exports